import { ELEMENT_TYPE__SOCIAL_INPUT } from '../../../../redux/constants';

export const shouldPromptForEmail = (element, participant) =>
  element?.type === ELEMENT_TYPE__SOCIAL_INPUT &&
  Boolean(element?.properties?.required) &&
  Boolean(participant?.promptForEmail);
